import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { baseRoutes } from '../../constants/routes.constants';
import { RootState } from '../../store';

interface RedirectIfAuthenticatedProps {
  children: React.ReactNode;
}

// Inverse of SearchEntryAuthGuard: an already-signed-in user landing on
// /sign-in (e.g. a stale bookmark, or browser back after logging in) should
// end up on the search page, not see the login form again.
const RedirectIfAuthenticated: React.FC<RedirectIfAuthenticatedProps> = ({ children }) => {
  const { isAuthenticated, authInitialized } = useSelector((state: RootState) => state.auth);

  if (!authInitialized) {
    return null;
  }

  if (isAuthenticated) {
    return <Navigate to={baseRoutes.root} replace />;
  }

  return <>{children}</>;
};

export default RedirectIfAuthenticated;
